import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import CommonReport from "./commonReport";

export default class FuelCardsPaymentReport extends CommonReport {
    formatData = (data) => {
        const columns = this.props.data.columns.slice(-3).map((column) => column.propertyName.replaceAll(".", "_"));
        const result = data.map((row) => {
            const { totalPrices, ...newRow } = row;
            columns.forEach((column, i) => {
                newRow[column] = totalPrices[i];
            });
            return newRow;
        });
        return result;
    };

    cellProps = (column) => ({
        Header: column.label,
        accessor: columnName(column).replaceAll(".", "_"),
        show: !column.isAdditionalColumn,
        Cell: (props) => <div className="long-text">{formatValue(props.value, column.clrType)}</div>,
        Footer: () => this.footerVal(column),
        ...typeSpecificProps(column),
    });

    tableExtraProps = () => ({ data: this.formatData(this.props.data.data) });
}
